module.exports = __webpack_public_path__ + "img/visa-cut2.edb32a80.jpg";